export function OutlineJoyasIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.9372 10.5936C21.9372 14.6492 19.4791 18.1366 15.9692 19.6385C16.1379 18.8454 16.1548 17.951 16.0142 17.0116C15.8623 15.8585 15.4854 14.6323 14.9004 13.4061H9.28677C8.71865 14.6323 8.35866 15.8585 8.20679 17.0116C8.08304 17.9622 8.10554 18.8622 8.27991 19.6666C4.73621 18.1816 2.25 14.6773 2.25 10.5936C2.25 5.15993 6.65993 0.75 12.0936 0.75C17.5273 0.75 21.9372 5.15993 21.9372 10.5936Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M5.0625 13.4062H9.28681C8.7187 14.6325 8.3587 15.8587 8.20683 17.0118C7.71746 16.6968 7.36309 16.3931 7.15497 16.2187C5.99061 15.2118 5.37187 14.0869 5.0625 13.4062Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1247 13.4062C18.821 14.0869 18.2135 15.2118 17.0604 16.2187C16.8635 16.3931 16.5091 16.6968 16.0141 17.0118C15.8623 15.8587 15.4854 14.6325 14.9004 13.4062H19.1247Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9692 19.6387C15.8004 20.5049 15.446 21.2586 14.906 21.8436C14.6473 22.1249 13.5954 23.2724 12.0823 23.2499C10.6199 23.233 9.62988 22.1474 9.35426 21.8436C8.81989 21.2643 8.46552 20.5161 8.2799 19.6668C8.10552 18.8624 8.08303 17.9624 8.20677 17.0118C8.35865 15.8587 8.71864 14.6325 9.28676 13.4062H14.9004C15.4854 14.6325 15.8623 15.8587 16.0142 17.0118C16.1548 17.9512 16.1379 18.8455 15.9692 19.6387Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.1943 4.41797V5.7792"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M16.1943 9.4082V10.7638"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M17.7468 6.1227C17.595 6.0552 17.3812 5.97083 17.1168 5.90333C16.8131 5.82458 16.5262 5.75146 16.1944 5.77958C16.0256 5.79646 15.2606 5.86396 15.0469 6.39832C14.9681 6.60645 14.9681 6.87082 15.0919 7.08456C15.2831 7.41643 15.705 7.51206 16.1944 7.62455C16.6444 7.7258 16.8244 7.68643 17.0887 7.87205C17.1843 7.93955 17.37 8.07455 17.4431 8.32204C17.5162 8.57516 17.4318 8.80016 17.3925 8.88453C17.2968 9.08703 17.1393 9.19391 17.0718 9.23891C16.8075 9.41328 16.5319 9.41328 16.1944 9.40765C15.6712 9.40203 15.2719 9.26703 15.0188 9.18266C14.7938 9.10391 14.6081 9.02516 14.4788 8.96328"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M7.9873 4.41797V5.7792"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M7.9873 9.4082V10.7638"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M9.5398 6.1227C9.38793 6.0552 9.17419 5.97083 8.90981 5.90333C8.60607 5.82458 8.3192 5.75146 7.98733 5.77958C7.81858 5.79646 7.05359 5.86396 6.83985 6.39832C6.7611 6.60645 6.7611 6.87082 6.88484 7.08456C7.07609 7.41643 7.49796 7.51206 7.98733 7.62455C8.43732 7.7258 8.61732 7.68643 8.88169 7.87205C8.97731 7.93955 9.16294 8.07455 9.23606 8.32204C9.30918 8.57516 9.22481 8.80016 9.18544 8.88453C9.08981 9.08703 8.93231 9.19391 8.86482 9.23891C8.60044 9.41328 8.32482 9.41328 7.98733 9.40765C7.46421 9.40203 7.06484 9.26703 6.81172 9.18266C6.58672 9.10391 6.4011 9.02516 6.27173 8.96328"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M12.1777 14.9531V16.3144"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M12.1777 19.9434V21.299"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M13.7302 16.6579C13.5784 16.5904 13.3646 16.506 13.1002 16.4385C12.7965 16.3597 12.5096 16.2866 12.1778 16.3147C12.009 16.3316 11.244 16.3991 11.0303 16.9335C10.9515 17.1416 10.9515 17.406 11.0753 17.6197C11.2665 17.9516 11.6884 18.0472 12.1778 18.1597C12.6278 18.261 12.8077 18.2216 13.0721 18.4072C13.1677 18.4747 13.3534 18.6097 13.4265 18.8572C13.4996 19.1103 13.4152 19.3353 13.3759 19.4197C13.2802 19.6222 13.1227 19.7291 13.0552 19.7741C12.7909 19.9484 12.5153 19.9484 12.1778 19.9428C11.6546 19.9372 11.2553 19.8022 11.0021 19.7178C10.7772 19.6391 10.5915 19.5603 10.4622 19.4984"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
    </svg>
  );
}
